export default __webpack_public_path__ + "static/media/SearchIcon.88b50cb4.svg";